import {
  getString,
  getInt32,
  getObject,
} from "@surya-digital/leo-ts-types";
import { CommonResultBreakdownDetails, CommonResultBreakdownDetailsDTO } from "./commonResultBreakdownDetails";

export interface SingleSelectNpsResultV1DTO {
  answer: string;
  rangeStart: number;
  rangeEnd: number;
  commonResultBreakdownDetails: CommonResultBreakdownDetailsDTO;
}

export class SingleSelectNpsResultV1 {
  readonly isSingleSelectNpsResultV1SingleSelectNpsResultV1: boolean = true;

  readonly answer: string;
  readonly rangeStart: number;
  readonly rangeEnd: number;
  readonly commonResultBreakdownDetails: CommonResultBreakdownDetails;

  static readonly constraints = {
    "answer": {
      "minSize": 3,
      "maxSize": 32,
      
      
      
      
    },
    "rangeStart": {
      "minValue": 0,
      "maxValue": 9,
    },
    "rangeEnd": {
      "minValue": 6,
      "maxValue": 10,
    },
  }

  constructor(
  answer: string, 
  rangeStart: number, 
  rangeEnd: number, 
  commonResultBreakdownDetails: CommonResultBreakdownDetails
  ) {
    SingleSelectNpsResultV1.validateAnswer(answer);
    this.answer = answer;
    SingleSelectNpsResultV1.validateRangeStart(rangeStart);
    this.rangeStart = rangeStart;
    SingleSelectNpsResultV1.validateRangeEnd(rangeEnd);
    this.rangeEnd = rangeEnd;
    this.commonResultBreakdownDetails = commonResultBreakdownDetails;
  }

  static fromDTO(dto: SingleSelectNpsResultV1DTO): SingleSelectNpsResultV1 {
    const answer = getString(dto, "answer", InvalidSingleSelectNpsResultV1AnswerError);
    const rangeStart = getInt32(dto, "rangeStart", InvalidSingleSelectNpsResultV1RangeStartError);
    const rangeEnd = getInt32(dto, "rangeEnd", InvalidSingleSelectNpsResultV1RangeEndError);
    const commonResultBreakdownDetails = CommonResultBreakdownDetails.fromDTO(getObject(dto, "commonResultBreakdownDetails", InvalidSingleSelectNpsResultV1CommonResultBreakdownDetailsError));
    return new SingleSelectNpsResultV1(
      answer,
      rangeStart,
      rangeEnd,
      commonResultBreakdownDetails
    );
  }

  toDTO(): SingleSelectNpsResultV1DTO {
    const dto: SingleSelectNpsResultV1DTO = {
        answer: this.answer,
        rangeStart: this.rangeStart,
        rangeEnd: this.rangeEnd,
        commonResultBreakdownDetails: this.commonResultBreakdownDetails.toDTO()
    };
    return dto;
  }
  private static validateAnswer = (answer: string): void => {
    if(answer.length < 3) {
      throw new InvalidSingleSelectNpsResultV1AnswerMinSizeError(
        3,
        `Attribute answer is too short. Size is ${answer.length}. Min size is 3.`
      );
    }
    if(answer.length > 32) {
      throw new InvalidSingleSelectNpsResultV1AnswerMaxSizeError(
        32,
        `Attribute answer is too long. Size is ${answer.length}. Max size is 32.`
      );
    }
      if(answer.trim().length === 0) {
        throw new InvalidSingleSelectNpsResultV1AnswerNonEmptyError(
          `Attribute answer cannot be an empty string.`
        );
      }
  }
  private static validateRangeStart = (rangeStart: number): void => {
    if(rangeStart < 0) {
      throw new InvalidSingleSelectNpsResultV1RangeStartMinValueError(
        0,
        `Attribute rangeStart has value ${rangeStart}. Min value is 0.`
      );
    }
    if(rangeStart > 9) {
      throw new InvalidSingleSelectNpsResultV1RangeStartMaxValueError(
        9,
        `Attribute rangeStart has value ${rangeStart}. Max value is 9.`
      );
    }
  }
  private static validateRangeEnd = (rangeEnd: number): void => {
    if(rangeEnd < 6) {
      throw new InvalidSingleSelectNpsResultV1RangeEndMinValueError(
        6,
        `Attribute rangeEnd has value ${rangeEnd}. Min value is 6.`
      );
    }
    if(rangeEnd > 10) {
      throw new InvalidSingleSelectNpsResultV1RangeEndMaxValueError(
        10,
        `Attribute rangeEnd has value ${rangeEnd}. Max value is 10.`
      );
    }
  }
  
}

SingleSelectNpsResultV1.prototype.toString = function toString(): string {
  return `SingleSelectNpsResultV1(answer='${this.answer}',rangeStart='${this.rangeStart}',rangeEnd='${this.rangeEnd}',commonResultBreakdownDetails='${this.commonResultBreakdownDetails}')`;
};

export class InvalidSingleSelectNpsResultV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectNpsResultV1Error";
  }
}
export class InvalidSingleSelectNpsResultV1AnswerError extends InvalidSingleSelectNpsResultV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectNpsResultV1AnswerError";
  }
}

export class InvalidSingleSelectNpsResultV1AnswerMaxSizeError extends InvalidSingleSelectNpsResultV1AnswerError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectNpsResultV1AnswerMaxSizeError";
  }
}

export class InvalidSingleSelectNpsResultV1AnswerMinSizeError extends InvalidSingleSelectNpsResultV1AnswerError {
  readonly minSize: number;
  constructor(minSize: number, message?: string) {
    super(message);
    this.minSize = minSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectNpsResultV1AnswerMinSizeError";
  }
}

export class InvalidSingleSelectNpsResultV1AnswerNonEmptyError extends InvalidSingleSelectNpsResultV1AnswerError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectNpsResultV1AnswerNonEmptyError";
  }
}

export class InvalidSingleSelectNpsResultV1RangeStartError extends InvalidSingleSelectNpsResultV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectNpsResultV1RangeStartError";
  }
}

export class InvalidSingleSelectNpsResultV1RangeStartMaxValueError extends InvalidSingleSelectNpsResultV1RangeStartError {
  readonly maxValue: number;
  constructor(maxValue: number, message?: string) {
    super(message);
    this.maxValue = maxValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectNpsResultV1RangeStartMaxValueError";
  }
}

export class InvalidSingleSelectNpsResultV1RangeStartMinValueError extends InvalidSingleSelectNpsResultV1RangeStartError {
  readonly minValue: number;
  constructor(minValue: number, message?: string) {
    super(message);
    this.minValue = minValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectNpsResultV1RangeStartMinValueError";
  }
}

export class InvalidSingleSelectNpsResultV1RangeEndError extends InvalidSingleSelectNpsResultV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectNpsResultV1RangeEndError";
  }
}

export class InvalidSingleSelectNpsResultV1RangeEndMaxValueError extends InvalidSingleSelectNpsResultV1RangeEndError {
  readonly maxValue: number;
  constructor(maxValue: number, message?: string) {
    super(message);
    this.maxValue = maxValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectNpsResultV1RangeEndMaxValueError";
  }
}

export class InvalidSingleSelectNpsResultV1RangeEndMinValueError extends InvalidSingleSelectNpsResultV1RangeEndError {
  readonly minValue: number;
  constructor(minValue: number, message?: string) {
    super(message);
    this.minValue = minValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectNpsResultV1RangeEndMinValueError";
  }
}

export class InvalidSingleSelectNpsResultV1CommonResultBreakdownDetailsError extends InvalidSingleSelectNpsResultV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSingleSelectNpsResultV1CommonResultBreakdownDetailsError";
  }
}
